import React from 'react'
import {Modal} from 'react-bootstrap'
import {Button} from '../../../../_gori/partials/widgets'
import {useIntl} from 'react-intl'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import {toast} from 'react-toastify'
import {KTSVG, blockPopUp} from '../../../../_gori/helpers'
import {useStatesGlobal} from '../../../../_gori/helpers/components/StatesGlobalProvider'

type Props = {
  show: boolean
  handleClose: () => void
  data: any // row data
}

export const TrackingNumbersModal: React.FC<Props> = ({show, handleClose, data}) => {
  const intl = useIntl()
  const {statesGlobal} = useStatesGlobal()
  const carriers = statesGlobal.carriers
  const carrierService = carriers[data.carrier + '_' + data.service] ?? []
  const trackingNumbers = data.tracking_numbers ?? []
  const trackingStatus = data.tracking_status

  return (
    <Modal
      show={show}
      onHide={handleClose}
      dialogClassName='modal-size-lg h-auto'
      contentClassName='modal-padding'
      id='gori_modal_view_tracking_numbers_shipment_detail'
      tabIndex={-1}
      aria-hidden='true'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title bsPrefix={'fw-bolder fs-1'}>
          {intl.formatMessage({id: 'TRACKING_NUMBERS'})}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='row'>
          <div className='col-12 d-flex mb-3' style={{color: '#94A3B8'}}>
            <div className='col-6 text-uppercase text-start fw-bolder fs-5 lh-lg'>
              {intl.formatMessage({id: 'TRACKING_NUMBER'})}:
            </div>
            <div className='col-6 text-uppercase text-start fw-bolder fs-5 lh-lg'>
              {intl.formatMessage({id: 'TRACKING_STATUS'})}
            </div>
          </div>
        </div>
        <div className='row'>
          {trackingNumbers.map((trackingNumber: string, index: number) => (
            <div key={index} className='col-12 my-3'>
              <div className='d-flex fs-5 fw-bold'>
                <div className='col-6 d-flex align-items-center'>
                  <span style={{color: '#A1A5B7', width: '25px'}}>{index + 1}.</span>
                  <span
                    className='text-primary cursor-pointer'
                    onClick={() => {
                      if (blockPopUp(carrierService?.visuals?.tracking_url + trackingNumber)) {
                        toast.warning(intl.formatMessage({id: 'POP_UP_IS_BLOCKED'}))
                      }
                    }}
                  >
                    {trackingNumber}
                  </span>
                  <CopyToClipboard
                    text={trackingNumber}
                    onCopy={() => toast.success(intl.formatMessage({id: 'COPIED'}))}
                  >
                    <div>
                      <div className='btn btn-active-color-primary btn-icon btn-sm btn-outline-light'>
                        <KTSVG path='/media/gori/account/copy.svg' className='svg-icon' />
                      </div>
                    </div>
                  </CopyToClipboard>
                </div>
                <div className='col-6 d-flex align-items-center text-capitalize'>
                  {trackingStatus}
                </div>
              </div>
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className='btn btn-advanced-secondary'
          label={intl.formatMessage({id: 'CLOSE'})}
          loadingText={intl.formatMessage({id: 'CLOSE'})}
          event={handleClose}
        />
      </Modal.Footer>
    </Modal>
  )
}
